module.exports = __webpack_public_path__ + "img/breakfast_bistro_menu3.445d0910.png";